import eventMixin from '../lib/eventMixin';
import Logger from "../utilities/Logger";

const classes = {
	open : 'theme-media-lightbox--open'
}

export default class ThemeMediaLightboxImage {

	static generateHtml(src) {
		const dom = document.createElement('div');
		dom.classList.add('theme-media-lightbox__image-container');
		dom.setAttribute('data-theme-media-lightbox-image-container', src);
		dom.setAttribute('data-theme-media-lightbox-close', true);

		const imgContainerDom = document.createElement('div');
		imgContainerDom.classList.add('theme-media-lightbox__image');
		imgContainerDom.setAttribute('data-theme-media-lightbox-image', "");
		dom.appendChild(imgContainerDom);

		return dom;
	}

	constructor(dom) {
		const NAME = 'ThemeMediaLightboxImage';
		Logger.log(`${NAME} > init`);

		this.dom = dom;
		this.imageSrc = dom.getAttribute('data-theme-media-lightbox-image-container');
		this.image = null;
	}

	createImage() {

		if(!this.image) {
			const img = document.createElement('img');
			img.src = this.imageSrc;

			this.dom.querySelector('[data-theme-media-lightbox-image]')?.appendChild(img);
	    return;
		}

	}

	// Called by ThemeMediaLightbox
	destroy() {
		if(this.image) {
			this.dom.innerHTML = '';
		}
	}

	// Called by ThemeMediaLightbox
	init() {
		this.createImage();
	}
}

// Mixins
Object.assign(ThemeMediaLightboxImage.prototype, eventMixin);
